module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKWiUNhoIqOjjg.6fd9f418.woff2";